module.exports = __webpack_public_path__ + "img/sec10desk.029b833c.png";